export const getIconSize = (size: string) => {
  if (size === 'lg') {
    return 24;
  }
  if (size === 'xl') {
    return 32;
  }
  if (size === 'md') {
    return 20;
  }
  if (size === 'sm') {
    return 16;
  }

  if (size === 'xs') {
    return 14;
  }
  
  if (size === 'xxs') {
    return 12;
  }
  return 16;
};
